
const SvgComponent = (props) => (
  <svg
    width={320}
    height={152}
    viewBox='0 0 320 152'
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      boxShadow: '0px 16px 32px 0px #43464A29, 0px 4px 12px -4px #43464A1F',
      borderRadius: 16
    }}
    {...props}
  >
    <rect width={320} height={152} rx={16} fill="#18181B" />
    <path stroke="#3F3F46" d="M227.5 28v44" />
    <rect x={243} y={47} width={24} height={24} rx={12} fill="#FFC61B" />
    <path
      d="M256.787 55.572c1.418 0 2.21.509 2.21.509l.003-2.19-.037-.01a10.377 10.377 0 0 0-2.674-.381c-3.008-.003-3.457 1.791-3.459 2.861l-.002 1.104-1.826-.002-.002 1.805 1.826.001-.001 1.278h-1.823v1.812h1.822l-.002 2.138 2.75.003.002-2.141h2.873l.546-1.812h-3.418l.002-1.274 2.871.003.547-1.805-3.417-.003.002-.769c0-.503-.009-1.127 1.207-1.127Z"
      fill="#fff"
    />
    <text
      fill="#fff"
      xmlSpace="preserve"
      style={{
        whiteSpace: "pre",
      }}
      fontFamily="Inter"
      fontSize={14}
      fontWeight={600}
      letterSpacing="0em"
    >
      <tspan x={275} y={64.091}>
        {"1.02"}
      </tspan>
    </text>
    <rect x={16} y={96} width={288} height={40} rx={8} fill="#7F39FA" />
  </svg>
)

export default SvgComponent
   